import React from 'react';
import { useFormik } from 'formik';
import { StatusCodes } from 'http-status-codes';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import WhitePad from '~/src/components/common/WhitePad/WhitePad';
import InventoryApi from '../../../../services/api/InventoryApi';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import { removeSchema } from '../InventorySchema';
import InventoryRemoveEditForm from '../components/InventoryRemoveEditForm';
import { InventoryRemoveFormik } from '~/src/types/InventoryRemoveFormik';
import { formikValuesAndItemToRemoveStockTransaction } from '~/src/types/convertors/formikValuesAndItemToRemoveStockTransaction';
import { createEmptyRemoveFormik } from '~/src/types/convertors/createEmptyRemoveFormik';

interface ParamTypes {
  genericId: string;
}

export default function InventoryRemove(): JSX.Element {
  const location = useLocation();
  const { genericId } = useParams<ParamTypes>();
  const { item } = location?.state ?? {};
  const history = useHistory();

  const saveItem = async (
    values: InventoryRemoveFormik,
    setSubmitting: (isSubmitting: boolean) => void,
  ): Promise<void> => {
    setSubmitting(true);

    const convertedValues = formikValuesAndItemToRemoveStockTransaction(values, item);
    const result = await InventoryApi.remove(convertedValues);
    if (result.status === StatusCodes.OK) {
      history.push(`/inventory/list-for-generic/in-warehouse/${item.warehouse.id}/${genericId}`);
    } else {
      setSubmitting(false);
    }
  };

  const initialValues = createEmptyRemoveFormik();
  const formik = useFormik({
    initialValues,
    validationSchema: removeSchema,
    onSubmit: async (values, { setSubmitting }) => {
      return saveItem(values, setSubmitting);
    },
  });

  return (
    <WhitePad isFluid>
      <> </>
      {item ? (
        <>
          <TitleComponent
            title="Outgoing Movements"
            onLeftHandler={(): void => {
              history.push(`/inventory/list-for-generic/${genericId}`);
            }}
          />
          <InventoryRemoveEditForm formikProps={formik} />
        </>
      ) : (
        <TitleComponent title="Please restart process from inventory page" />
      )}
    </WhitePad>
  );
}
